import Box from 'UIKit/Box/Box'
import Carousel from 'UIKit/Carousel'
import Image from 'UIKit/Image'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import getExternalLinkProps from 'utils/getExternalLinkProps'
import { RowCenter } from '../Row'

const BASE_URL = '/images/partner'

type Partner = {
  url: string
  src: string
  alt: string
  id: string
  isSupportSEO?: boolean
}

const partners: Partner[] = [
  {
    url: 'https://deficasinos.io/casino/hunnyplay/',
    src: `${BASE_URL}/defi-casinos.png`,
    alt: 'Defi Casinos Logo',
    id: 'defi-casinos',
  },
  {
    url: 'https://cryptogamble.com/casino/reviews/hunnyplay',
    src: `${BASE_URL}/crypto-gamble-logo.png`,
    alt: 'CryptoGameble Logo',
    id: 'crypto-gamble',
  },
  {
    url: 'https://www.btcgosu.com/review/hunnyplay-casino/',
    src: `${BASE_URL}/btc-gosu.png`,
    alt: 'BTCGosu Logo',
    id: 'btc-gosu',
  },
  {
    url: 'https://www.begambleaware.org',
    src: `${BASE_URL}/be-gamble-aware.png`,
    alt: 'BeGambleAware Logo',
    id: 'be-gamble-aware',
  },
  {
    url: 'https://www.affplus.com/n/hunnyplayaffiliates',
    src: `${BASE_URL}/aff-plus.png`,
    alt: 'AFFPlus Logo',
    id: 'aff-plus',
  },
  {
    url: 'https://www.affpaying.com/hunnyplayaffiliates',
    src: `${BASE_URL}/aff-paying.png`,
    alt: 'AffPaying Logo',
    id: 'aff-paying',
  },
  {
    url: 'https://casinobonusesfinder.co.uk/no-deposit-bonus/',
    src: `${BASE_URL}/casino-finder.png`,
    alt: 'Casino Bonuses Finder Logo',
    id: 'casino-bonuses-finder',
  },
  {
    url: 'https://coingambling.info/',
    src: `${BASE_URL}/coin-gambling.png`,
    alt: 'CoinGambling Logo',
    id: 'coin-gambling',
  },
  {
    url: 'https://viperslots.com/',
    src: `${BASE_URL}/viperslots.png`,
    alt: 'ViperSlots Logo',
    id: 'viperslots',
  },
  {
    url: 'https://gamblescope.com/',
    src: `${BASE_URL}/gamblescope.png`,
    alt: 'Gamblescope Logo',
    id: 'gamblescope',
  },
  {
    url: 'https://www.casinocritique.com/casino/hunnyplay-casino-review/',
    src: `${BASE_URL}/casino-critique.png`,
    alt: 'Casino Critique Logo',
    id: 'casino-critique',
  },
  {
    url: 'https://www.demoslot.com',
    src: `${BASE_URL}/demoslot.png`,
    alt: 'Demoslot Logo',
    id: 'demoslot',
    isSupportSEO: true,
  },
  {
    url: 'https://toncasinos.com/',
    src: `${BASE_URL}/ton-casino.png`,
    alt: 'TON Casino logo',
    id: 'ton-casino',
  },
  {
    url: 'https://new-casinos.co.nz/',
    src: `${BASE_URL}/new-casinos.png`,
    alt: 'New casinos logo',
    id: 'new-casinos',
  },
  {
    url: 'https://danskonlinecasino.dk/',
    src: `${BASE_URL}/danske-casino-logo.png`,
    alt: 'Danske Online casino logo',
    id: 'danskeonline-casino',
  },
  {
    url: 'https://nyecasino.com/',
    src: `${BASE_URL}/nye-casino.png`,
    alt: 'Nye casino logo',
    id: 'nye-casio',
  },
  {
    url: 'https://onlinecasinobelgie.com/',
    src: `${BASE_URL}/belgie-casino.png`,
    alt: 'Belgie Casino logo',
    id: 'bilgie-casino',
  },
  {
    url: 'https://freespinscasinoer.dk/',
    src: `${BASE_URL}/free-spins-casinoer.png`,
    alt: 'Free Spins Casinoer',
    id: 'free-spins-casioer',
  },
  {
    url: 'https://slotyi.com/',
    src: `${BASE_URL}/slotyi.png`,
    alt: 'SLOTyi logo',
    id: 'slotyi-casino',
  },
  {
    url: 'https://www.nodepositwow.com/',
    src: `${BASE_URL}/nodeposit-wow.png`,
    alt: 'No Deposit Wow logo',
    id: 'nodeposit-wow',
  },
  {
    url: 'https://bonustly.com/',
    src: `${BASE_URL}/bonustly.png`,
    alt: 'Bonustly logo',
    id: 'bonustly',
  },
]

const HunnyPartner: React.FC = () => {
  const { isTablet, isMobile, isXl, isXxl, isMd } = useMatchBreakpoints()

  const slideAffiliatePerView = useMemo(() => {
    if (isMobile) return 4

    if (isTablet) return 5

    if (isXl) return 6
    if (isXxl) return 7

    return 8
  }, [isMobile, isTablet, isXl, isXxl])

  const slidesAffiliatePartner = useMemo(
    () =>
      partners.map((partner, index) => ({
        key: `slide-affiliate_${index}`,
        content: (
          <RowCenter
            width="100%"
            height="100%"
            key={`partner-${partner.id}`}
            px={['8px', '', '', '16px']}
            id={partner.id}
            as="a"
            aria-label={partner.id}
            href={partner.url}
            {...getExternalLinkProps()}
            rel={partner.isSupportSEO ? 'dofollow' : 'nofollow'}
          >
            <StyledImage width={123} height={48} src={partner.src} alt={partner.alt} />
          </RowCenter>
        ),
      })),
    [],
  )

  const slidePerView = useMemo(() => {
    if (isMobile || isMd) return 4

    if (isTablet) return 5

    if (isXl) return 6

    return 7
  }, [isMobile, isTablet, isXl, isMd])

  const arrLinkPartner = useMemo(
    () => [
      {
        url: 'https://coinmarketcap.com/currencies/pancake-hunny/',
        src: `${BASE_URL}/coinmarketcap.png`,
        id: 'coinmarketcap',
      },
      {
        url: 'https://www.coingecko.com/en/coins/pancake-hunny',
        src: `${BASE_URL}/coingecko.png`,
        id: 'coingecko',
      },
      {
        url: '#tokenpocket',
        src: `${BASE_URL}/tokenpocket.png`,
        id: 'tokenpocket',
      },
      {
        url: 'https://bscscan.com/token/0x565b72163f17849832a692a3c5928cc502f46d69',
        src: `${BASE_URL}/bscscan.png`,
        id: 'bscscan',
      },
      {
        url: 'https://dappradar.com/dapp/hunnyplay',
        src: `${BASE_URL}/dappradar.png`,
        id: 'dappradar',
      },
      {
        url: 'https://defillama.com/protocol/hunny-finance',
        src: `${BASE_URL}/defillama.png`,
        id: 'defillama',
      },
      {
        url: 'https://debank.com/profile/0xc0eb6d598ba0bdb45f3915a32fe3289482ebfdf5 ',
        src: `${BASE_URL}/debank.png`,
        id: 'debank',
      },
    ],
    [],
  )

  const slides = useMemo(
    () =>
      arrLinkPartner.map((item, index) => ({
        key: `slide-partner_${index}`,
        content: (
          <RowCenter
            id={item.id}
            as="a"
            aria-label={item.id}
            href={item.url}
            width="100%"
            height="100%"
            px={['8px', '', '', '16px']}
            {...getExternalLinkProps()}
          >
            <StyledImagePartner width={120} height={28} src={item.src} alt="partner" />
          </RowCenter>
        ),
      })),
    [arrLinkPartner],
  )

  return (
    <StyledNav id="partner">
      <StyledWrapPartner>
        <Carousel
          autoplay
          slidesPerView={slideAffiliatePerView}
          slides={slidesAffiliatePartner}
          pb={['28px', '', '', '48px']}
        />
      </StyledWrapPartner>
      <StyledContainer py={['0px', '', '', '8px']}>
        <Carousel autoplay slidesPerView={slidePerView} slides={slides} pb={['28px', '', '', '28px']} />
      </StyledContainer>
    </StyledNav>
  )
}

const StyledImage = styled(Image)`
  width: 100%;

  img {
    max-height: 28px;
    object-fit: contain;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    img {
      max-height: 48px;
    }
  }
`
const StyledImagePartner = styled(Image)`
  width: 100%;

  img {
    max-height: 20px;
    object-fit: contain;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    img {
      max-height: 28px;
    }
  }
`

const StyledNav = styled.nav`
  width: 100%;
`

const StyledWrapPartner = styled(RowCenter)`
  margin: 10px 0;
  padding: 4px 0;
  border-top: 1px;
  border-bottom: 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.buttonBackgroundAlt2};

  mix-blend-mode: luminosity;
  opacity: 0.8;
  width: 100%;
`

const StyledContainer = styled(Box)`
  mix-blend-mode: luminosity;
  opacity: 0.8;
  width: 100%;
`
export default HunnyPartner
